import { useAuth } from "@/lib/auth";
import { WannlabsSwitcher } from "@/components/wannlabs-switcher";
import { BrandLogo } from "@/components/brand-logo";
import { MarketingAuthNav } from "@/components/marketing-auth-nav";
import { isDesktopShell } from "@/lib/desktop-shell";
import { Link } from "react-router-dom";

const nav = [
  { href: "/#product", label: "Product" },
  { href: "/#how-it-works", label: "How it works" },
  { href: "/#life", label: "Stories" },
  { href: "/#screens", label: "Screens" },
  { href: "/pricing", label: "Pricing" },
] as const;

export function SiteHeader({
  googleConfigured: _googleConfigured = false,
  demoAllowed: _demoAllowed = false,
}: {
  googleConfigured?: boolean;
  demoAllowed?: boolean;
}) {
  void _googleConfigured;
  void _demoAllowed;
  const desktop = isDesktopShell();
  const { user, status } = useAuth();
  const signedIn = status === "authenticated" && Boolean(user);
  return (
    <header className="sticky top-0 z-40 border-b border-white/50 bg-white/55 backdrop-blur-2xl">
      <div className="mx-auto flex max-w-[90rem] items-center justify-between gap-4 px-4 py-3 md:px-8 xl:px-10">
        <div className="flex min-w-0 items-center gap-1">
          <WannlabsSwitcher />
          {/* Shared header rule: the logo opens this app's dashboard when signed in. */}
          <BrandLogo href={desktop ? "/login" : signedIn ? "/dashboard" : "/"} />
        </div>
        {desktop ? null : (
          <nav
            className="hidden items-center gap-1 md:flex"
            aria-label="Marketing"
          >
            {nav.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="rounded-full px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-white/70 hover:text-slate-900"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
        <MarketingAuthNav />
      </div>
    </header>
  );
}
